module.exports = __webpack_public_path__ + "static/media/25114629_1545557735493862_936959943_n.be9b5839.jpg";